import { Container } from "./style"


const Cabecalho = () => {
  return (
    <Container>
        <h1>Kenzie Shop - Hortifrut</h1>
        <img src="https://www.multibeneficiosgpa.com.br/wp-content/uploads/2020/05/1588193759_2474Maio051132x566pxV1b.jpg"
        alt="Hortifuit"/>
    </Container>
    
  )
}

export default Cabecalho